export default __webpack_public_path__ + "static/media/GIV-icon-Text-fill.be4e349c.svg";